<template>
    <div>
        <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" class="form">
            <fieldset>

                <div class="form__legend">Registrační formulář na akci Most mezi generacemi, aneb LEGO spojuje</div>

                <div class="form__row">
                    <div class="form__controls--no-label tw-grid tw-grid-cols-2">
                        <label>
                            <input type="radio" value="Student" class="mr-2" v-model="form.role">
                            Student
                        </label>
                        <label>
                            <input type="radio" value="Senior" class="mr-2" v-model="form.role">
                            Senior
                        </label>
                        <label>
                            <input type="radio" value="Expert" class="mr-2" v-model="form.role">
                            Expert z oboru
                        </label>
                        <label>
                            <input type="radio" value="Zak" class="mr-2" v-model="form.role">
                            Žák ZŠ
                        </label>
                        <label>
                            <input type="radio" value="StudentSS" class="mr-2" v-model="form.role">
                            Student SŠ
                        </label>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Jméno</label>
                    <div class="form__controls">
                        <input type="text" name="first_name" v-model="form.first_name" placeholder="Jméno">
                        <div class="form__error" v-html="form.errors.get('first_name')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Příjmení</label>
                    <div class="form__controls">
                        <input type="text" name="last_name" v-model="form.last_name" placeholder="Příjmení">
                        <div class="form__error" v-html="form.errors.get('last_name')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Email</label>
                    <div class="form__controls">
                        <input type="email" name="email" v-model="form.email" placeholder="Email">
                        <div class="form__error" v-html="form.errors.get('email')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Telefon</label>
                    <div class="form__controls">
                        <input type="text" name="phone" v-model="form.phone" placeholder="Telefon">
                        <div class="form__error" v-html="form.errors.get('phone')"></div>
                    </div>
                </div>

                <div class="form__row form--required" v-if="form.role == 'Student'">
                    <label>Program</label>
                    <div class="form__controls">
                        <select name="field" v-model="form.field" @change="form.errors.clear('field')">
                            <option value="" disabled selected>Vyberte program</option>
                            <option v-for="(programme, key) in programmes" :value="key">{{ programme }}</option>
                        </select>
                        <div class="form__error" v-html="form.errors.get('field')"></div>
                    </div>
                </div>

                <div class="form__row form--required" v-if="form.role == 'Zak' || form.role == 'StudentSS'">
                    <label>Věk</label>
                    <div class="form__controls">
                        <input type="text" name="age" v-model="form.age" placeholder="Věk">
                        <div class="form__error" v-html="form.errors.get('age')"></div>
                    </div>
                </div>

                <div class="form__row form--required" v-if="form.role == 'StudentSS'">
                    <label>Škola</label>
                    <div class="form__controls">
                        <input type="text" name="school" v-model="form.school" placeholder="Škola">
                        <div class="form__error" v-html="form.errors.get('school')"></div>
                    </div>
                </div>

                <div class="form__row form--required" v-if="form.role == 'Expert'">
                    <label>Název firmy</label>
                    <div class="form__controls">
                        <input type="text" name="company_name" v-model="form.company_name" placeholder="Název firmy">
                        <div class="form__error" v-html="form.errors.get('company_name')"></div>
                    </div>
                </div>

                <div class="form__row form--required" v-if="form.role == 'Expert'">
                    <label>Pozice ve firmě</label>
                    <div class="form__controls">
                        <input type="text" name="company_position" v-model="form.company_position" placeholder="Pozice ve firmě">
                        <div class="form__error" v-html="form.errors.get('company_position')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__controls--no-label">
                        <label class="form__checkbox">
                            <input type="checkbox" name="terms" value="1" class="mr-2" v-model="form.terms" @change="form.errors.clear('terms')">
                            Souhlasím s <a :href="url('/podminky-registrace')" target="_blank">podmínkami registrace</a>
                        </label>
                        <div class="form__error" v-html="form.errors.get('terms')"></div>
                    </div>
                </div>

                <div class="form__controls--no-label">
                    <button type="submit" class="btn btn-primary">
                        Odeslat
                        <i class="fa fa-fw fa-spinner fa-pulse" v-if="sending"></i>
                        <i class="fa fa-fw fa-chevron-right" v-else></i>
                    </button>
                </div>

            </fieldset>

        </form>
    </div>
</template>

<script>
    import Form from '../vn/Form.js';
    export default {

        props: {
            senior: {
                default: 0
            }
        },

        data() {
            return {
                form: new Form({
                    first_name: '',
                    last_name: '',
                    phone: '',
                    email: '',
                    field: '',
                    role: 'Student',
                    age: null,
                    school: null,
                    company_name: null,
                    company_position: null,
                    terms: false
                }),
                programmes: {
                    ip: 'Inovativní podnikání (IP)',
                    pae: 'Provoz a ekonomika (PAE)',
                    paa: 'Podnikání a administrativa (PAA)',
                    info: 'Informatika (INFO)',
                    syi: 'Systémové inženýrství (SYI)',
                    hks: 'Hospodářská a kulturní studia (HKS)',
                    vsrr: 'Veřejná správa a regionální rozvoj (VSRR)',
                    em: 'Economics and Management (EM)',
                    infoa: 'Informatics (INFOA)',
                    ba: 'Business Administration (BA)',
                    paen: 'Provoz a ekonomika - navazující (PAEN)',
                    paan: 'Podnikání a administrativa - navazující (PAAN)',
                    infon: 'Informatika - navazující (INFON)',
                    vsrrn: 'Veřejná správa a regionální rozvoj - navazující (VSRRN)',
                    hksn: 'Hospodářská a kulturní studia - navazující (HKSN)',
                    syin: 'Systémové inženýrství - navazující (SYIN)',
                    prn: 'Projektové řízení (PRN)',
                    eadan: 'European Agrarian Diplomacy - navazující (EADAN)',
                    infoan: 'Informatics - navazující (INFOAN)',
                    emn: 'Economics and Management - navazující (EMN)',
                    ban: 'Business Administration - navazující (BAN)',
                },
                sending: false
            }
        },

        methods: {
            onSubmit() {
                this.sending = true;
                this.form.post(url('/most/lego'))
                    .then(response => {
                        this.sending = false;

                        if (response.status !== 'success') {
                            console.log(response);
                            alert('Chyba při odesílání formuláře');
                            return;
                        }

                        window.location.assign(url('/most/podekovani'));
                    })
                    .catch(errors => {
                        this.sending = false;
                        // other than validation error
                        if (errors.status !== 422) {
                            console.log(errors);
                            alert('Chyba při odesílání formuláře');
                        }
                    });
            }
        }
    }
</script>
